import { render, staticRenderFns } from "./SwitchState.vue?vue&type=template&id=10c62f7c"
import script from "./SwitchState.vue?vue&type=script&lang=js"
export * from "./SwitchState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports